import { useMemo } from 'react';
import { SEASONAL_THEMES, DEFAULT_LOGO } from '../constants/navigationConfig';

/**
 * Hook para gerenciar temas sazonais
 * @returns {Object} Tema atual com logo e alt
 */
export const useSeasonalTheme = () => {
  const currentTheme = useMemo(() => {
    const now = new Date();
    const activeTheme = SEASONAL_THEMES.find(({ start, end }) => now >= start && now <= end);
    return activeTheme || DEFAULT_LOGO;
  }, []);

  return currentTheme;
};